import { Link } from 'react-router'
import { AppShell } from '../../app/AppShell'
import { Button, Card } from '../../design/components'
import { useLiveSessions } from '../../domains/live/queries'
import styles from '../../domains/live/live.module.css'

/**
 * Every fight you could be watching.
 *
 * The screen exists to answer one question — **is this one mine?** — so the answer is what the row
 * leads with. The server derives it (`yourCharacterId`) rather than making the client cross-check
 * its own roster against every encounter's sides.
 */
export function LiveSessionListPage() {
  // Polling on: this is the screen where someone is waiting for a session to appear, and where a
  // hub that never connected would otherwise look like a quiet evening.
  const sessions = useLiveSessions(true, { poll: true })

  return (
    <AppShell title="Live" subtitle="SESSIONS IN PLAY">
      <Card variant="powers" label="Happening now">
        {sessions.isPending ? (
          <p className={styles.note}>Looking…</p>
        ) : sessions.isError ? (
          <p className={styles.note}>Could not read the sessions.</p>
        ) : sessions.data.length === 0 ? (
          <p className={styles.note}>
            Nothing is running. When a Game Master starts a fight in one of your campaigns, it
            appears here — and you will be told.
          </p>
        ) : (
          sessions.data.map((session) => (
            <div key={session.sessionId} className={styles.sessionRow}>
              {session.mapImageUrl !== null && (
                <img
                  className={styles.sessionThumb}
                  src={session.mapImageUrl}
                  alt=""
                  loading="lazy"
                />
              )}

              <span className={styles.sessionMain}>
                <span className={styles.sessionName}>{session.name}</span>
                {/* A session can now run with nowhere to be, so the place is one of two things
                    this line might say rather than something it always says. */}
                <span className={styles.rowMeta}>
                  {[session.locationName, session.campaignName]
                    .filter((part) => part !== null && part !== '')
                    .join(' · ')}
                </span>

                {session.yourCharacterName !== null ? (
                  <span className={styles.yours}>{session.yourCharacterName} is in this</span>
                ) : session.isGameMaster ? (
                  <span className={styles.rowMeta}>You are running it</span>
                ) : (
                  <span className={styles.rowMeta}>None of your characters is in it</span>
                )}
              </span>

              <Link to={`/live/${session.sessionId}`}>
                <Button variant="secondary">{session.isGameMaster ? 'Run' : 'Watch'}</Button>
              </Link>
            </div>
          ))
        )}
      </Card>
    </AppShell>
  )
}
